/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelPnnLane.ts                       *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/pnn-lane";

export class AutogenModelPnnLane<RowType extends ModelRow> extends Endpoint<RowType, RowPnnLaneFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowPnnLane extends ModelRow<RowPnnLaneFields> {
	constructor(values?: Partial<RowPnnLaneFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowPnnLaneFields {
	builder_profile_date: Date;
	builder_profile_id: string;
	company_id: string;
	destination: string;
	destination_exclude: string;
	destination_type: string;
	equipment_type: string;
	id: string;
	lane_number: number;
	lane_type: string;
	master_id: string;
	master_type: string;
	origin: string;
	origin_exclude: string;
	origin_type: string;
	reply_to_users: string;
	sendto_detail: string;
	sendto_name: string;
	sendto_unsubscribe_date: Date;
	topmatch_override: string;
}

